import { render } from "./ChulhaAssignMod.vue?vue&type=template&id=6c26ef95&scoped=true"
import script from "./ChulhaAssignMod.vue?vue&type=script&lang=js"
export * from "./ChulhaAssignMod.vue?vue&type=script&lang=js"

import "./ChulhaAssignMod.vue?vue&type=style&index=0&id=6c26ef95&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c26ef95"

export default script